'use strict'

//import ColorSample from '../models/ColorSample'
import CustomHarmonies from './CustomHarmonies'
import CXGrayImagePixelMutableArray from './CXGrayImagePixelMutableArray'

const ActionType = Object.freeze({
    ActionTypeMagicPaint: 0,
    ActionTypePaint: 1,
    ActionTypeErase: 2,
    ActionTypeEraseMaskColor: 3,
    ActionTypeChangeColorSample: 4,
})

class CXImageAction {
    constructor(action) {
        /*
         Pixels painted, in manual or polygon paint we just paint at the level 0,
         in the magic paint we add pixels at different levele of the magic painting and we set the paintLevel to the level set in the algorithm
        */

        this.pixelsPerLevel = [] // array of CXGrayImagePixelMutableArray objects
        this.pixelsPerLevelIndexes = [] // array of CXGrayImagePixelMutableArray objects
        this.paintLevel = 0 // int
        this.actionType // ActionType

        this.erasedColor
        this.erasedColorMaskNumber // int

        this.oldColor = new Map()
        this.color = new Map()
        this.oldWorkingPos = 0
        this.newWorkingPos = 0

        if (action) {
            this.initWithActionType(action)
        }
    }

    static get ActionType() {
        return ActionType
    }

    /**
     *
     * @param {ActionType} anActionType
     * @returns
     */
    initWithActionType(anActionType) {
        // Custom initialization
        this.actionType = anActionType

        if (anActionType !== ActionType.ActionTypeChangeColorSample) {
            this.pixelsPerLevel = []
            this.pixelsPerLevelIndexes = []
            this.pixelsPerLevel.push(new CXGrayImagePixelMutableArray())
            this.paintLevel = 0
        }
    }

    /**
     *
     * @param {Color} erasedColor
     * @param {int} erasedMaskNumber // atMaskColorNumber
     * @returns
     */
    initWithAsEraseMaskColorActionWithColor(erasedColor, erasedMaskNumber) {
        console.log('initWithAsEraseMaskColorActionWithColor')

        this.initWithActionType(ActionType.ActionTypeEraseMaskColor)

        //let temp = new ColorSample()
        //temp.colors = new Map(JSON.parse(JSON.stringify(Array.from(erasedColor.colors))))

        // Custom initialization
        //this.eraseColor = temp

        // Snapshot of ColorSample state (no callbacks, pure data)
        this.eraseColor = {
            colors: new Map(erasedColor.colors),
            workingColorPos: erasedColor.workingColorPos,
        }

        this.erasedColorMaskNumber = parseInt(erasedMaskNumber, 10)
    }

    initWithActionTypeMagicPaint() {
        console.log('initWithActionTypeMagicPaint')
        this.actionType = ActionType.ActionTypeMagicPaint
        this.pixelsPerLevel = []
        this.pixelsPerLevel.push(new CXGrayImagePixelMutableArray())
        this.pixelsPerLevelIndexes = []
    }

    /**
     *
     * @param {ColorSample} oldColorSample
     * @returns
     */
    initAsColorSampleChangeAction(oldColorSample) {
        console.log('initAsColorSampleChangeAction')
        this.actionType = ActionType.ActionTypeChangeColorSample

        //this.oldColor = new Map()
        //this.color = new Map()

        //const sortedColorMap = new Map([...oldColorSample.colors].sort((a, b) => a[0] - b[0]))

        //let i = 1
        //for (let [key, color] of sortedColorMap) {
        //    this.oldColor.set(i, color)
        //    i++
        //}

        // Snapshot original state
        this.oldColor = new Map(oldColorSample.colors)
        this.oldWorkingPos = oldColorSample.workingColorPos

        // Will be filled by setNewColorSampleForColorSampleChangeAction
        this.color = new Map()
        this.newWorkingPos = oldColorSample.workingColorPos
    }

    /**
     * Return lastLevePixels object
     * @returns CXGrayImagePixelMutableArray
     */
    lastLevelpixels() {
        return this.pixelsPerLevel[this.pixelsPerLevel.length - 1]
    }

    setLevelpixelsAtIndex(values, index) {
        this.pixelsPerLevel[index] = values
    }

    getLevelpixelsAtIndex(index) {
        return this.pixelsPerLevel[index]
    }

    cleanPixelsForMagicPaintAction() {
        const numberOfLevels = this.pixelsPerLevel.count() - 1
        for (let i = this.paintLevel; i < numberOfLevels; i++) {
            this.pixelsPerLevel.pop()
        }
    }

    resetLevelpixels() {
        this.pixelsPerLevel = []
        this.pixelsPerLevel.push(new CXGrayImagePixelMutableArray())
    }

    setColorSample(newColorSample) {
        this.color = newColorSample
    }

    /**
     *
     * @param {ColorSample} newColorSample
     */
    setNewColorSampleForColorSampleChangeAction(newColorSample) {
        if (this.actionType === ActionType.ActionTypeChangeColorSample) {
            //let i = 1
            //const sortedColorMap = new Map([...newColorSample.colors].sort((a, b) => a[0] - b[0]))
            //for (let [key, color] of sortedColorMap) {
            //    this.color.set(i, color)
            //    i++
            //}

            this.color = new Map(newColorSample.colors)
            this.newWorkingPos = newColorSample.workingColorPos
        }
    }

    /**
     *
     * @param {ColorSample} old colorSample
     */
    undoColorSampleChangeAction(currentColorSample) {
        console.info('undoColorSampleChangeAction')
        if (this.actionType === ActionType.ActionTypeChangeColorSample) {
            for (let i = CustomHarmonies.maxNumberOfColorsInColorSample(); i >= 1; i--) {
                const swatchColor = currentColorSample.getColorByNumber(i)

                if (typeof swatchColor !== 'undefined') {
                    currentColorSample.setColorByNumber(i, swatchColor)
                } else {
                    currentColorSample.deleteColorNumber(i)
                }
            }
        }

        return currentColorSample
    }

    /**
     *
     * @param {ColorSample} colorSample
     */
    redoColorSampleChangeAction(colorSample) {
        if (this.actionType === ActionType.ActionTypeChangeColorSample) {
            for (let i = 1; i <= CustomHarmonies.maxNumberOfColorsInColorSample(); i++) {
                const swatchColor = this.color.get(i)
                // let color = colorSample.getColorByNumber(i);

                if (!swatchColor) {
                    colorSample.setColorByNumber(i, swatchColor)
                }
            }
        }

        return colorSample
    }

    /**
     * @param {ColorSample} colorSample
     * @returns {ColorSample} colorSample
     */
    undoEraseMaskColorAction(colorSample) {
        console.log('undoEraseMaskColorAction')
        if (this.actionType === ActionType.ActionTypeEraseMaskColor) {
            colorSample.addSwatchColor(this.erasedSwatchColor)

            colorSample.setColorByNumber(colorSample.numberOfColors(), this.eraseColor)
            colorSample.moveColorNumber(colorSample.numberOfColors(), this.erasedColorMaskNumber)

            return colorSample
        }
    }

    /**
     *
     * @param {ColorSample} colorSample
     */
    redoEraseMaskColorAction(colorSample) {
        if (this.actionType === ActionType.ActionTypeEraseMaskColor) {
            colorSample.deleteColorNumber(this.erasedColorMaskNumber)
        }
    }
}
export default CXImageAction
